import { reactive, ref } from 'vue'

const state = reactive({
  progressStages: {},
  progresses: {},
  overallProgress:  0
});

/**
 * Handle loading progress in stages
 */
export function useProgressManager() {
  function setProgressStage(key, start, end) {
    state.progressStages[key] = { start, end }
  }

  function resetProgressStages() {
    state.progressStages = {}
  }

  function setStageProgress(key, progress, refresh = true) {
    // console.log('Setting progress for stage %s to %s', key, progress)
    state.progresses[key] = progress

    if (refresh) {
      refreshOverallProgress()
    }
  }

  function completeProgress() {
    const stages = Object.keys(state.progressStages)
    stages.forEach(stage => {
      setStageProgress(stage, 100, false)
    })

    refreshOverallProgress()
  }

  function refreshOverallProgress() {
    const progressValues = Object.values(state.progresses)
    const progressStages = Object.values(state.progressStages)

    // Calculate the weighted progress for each stage and sum them up
    state.overallProgress = progressValues.reduce((acc, progress, index) => {
      const { start, end } = progressStages[index]
      const weight = (end - start) / 100
      return acc + (Number(progress) * weight)
    }, 0)
  }

  return {
    setProgressStage,
    resetProgressStages,
    setStageProgress,
    completeProgress,
    get progress() {
      return state.overallProgress
    }
  }
}
